import { envPublic, warnIfMissingCloudFunctionUrlInDev } from '@/libs/config';
import { getAuthToken } from '@/libs/firebase/auth';
import { applyInterceptors, createApiClient } from '../api-client';
import { createApiFactory } from '../api-factory';
import { createFirebaseCloudFunctionsAbortInterceptor } from '../firebase-cloud-functions-scope';
import {
  createAuthInterceptor,
  createDebugLogRequestInterceptor,
  createDebugLogResponseInterceptor,
  createErrorInterceptor,
  createNetworkCheckInterceptor,
  createNetworkRetryInterceptor,
  createServerErrorAlertInterceptor,
  createUsKidsGolfBaseUrlInterceptor,
} from '../interceptors';
import type { TokenProvider } from '../types';

const defaultVersion = 'v1';

const firebaseTokenProvider: TokenProvider = {
  getAccessToken: async () => {
    return await getAuthToken();
  },
  getRefreshToken: async () => null,
  setTokens: async () => {},
  clearTokens: async () => {},
};

warnIfMissingCloudFunctionUrlInDev();

// `baseURL` here is just the dev default; the request interceptor below
// overrides it per-request based on the selected Firebase env.
const client = createApiClient({
  baseURL: envPublic.usKidGolfApiUrl,
});

applyInterceptors(
  client,
  [
    createDebugLogRequestInterceptor(),
    createUsKidsGolfBaseUrlInterceptor(),
    createFirebaseCloudFunctionsAbortInterceptor(),
    createAuthInterceptor(firebaseTokenProvider),
    createNetworkCheckInterceptor(),
  ],
  [
    createDebugLogResponseInterceptor(),
    createNetworkRetryInterceptor(client),
    createErrorInterceptor(),
    createServerErrorAlertInterceptor(),
  ],
);

export const usKidsGolfService = createApiFactory(client);

export const buildUrl = (path: string, version?: string) => {
  const v = version || defaultVersion;
  return `/api/${v}${path}`;
};
